import { Helmet } from "react-helmet-async";

export default function DynamicTitle(props) {
  return (
    <Helmet>
      <title>{props.pageTitle}</title>
      <meta name={props.pageMeta} content="Grupo Krause" />
      <meta name="description" content={props.pageContent} />
    </Helmet>
  );
}
